import { useTooltip } from '@/composables/useTooltip'
import { vTooltip } from 'floating-vue'

export default {
    created () {
        useTooltip('info-tooltip')
    },
    directives: {
       tooltip: vTooltip
    },
    methods: {
        createTooltip (content) {
            return {
                content,
                theme: 'info-tooltip'
            }
        }
    }
}
